import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const drawerWidth = 220;

export default function Sidebar() {
  const { admin } = useContext(AuthContext);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": { width: drawerWidth },
      }}
    >
      <Toolbar />

      <List>
        {/* COMMON */}
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/dashboard">
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        </ListItem>

        {/* 🏙️ CITY ADMIN ONLY */}
        {admin?.role === "CITY_ADMIN" && (
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/zonal-admins">
              <ListItemText primary="Zonal Admins" />
            </ListItemButton>
          </ListItem>
        )}

        {/* 📍 ZONAL ADMIN ONLY (Everything else is nested here) */}
        {admin?.role === "ZONAL_ADMIN" && (
          <>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/tags">
                <ListItemText primary="Food Tags" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/vendors">
                <ListItemText primary="My Vendors" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/batches">
                <ListItemText primary="Batches" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/delivery-boys">
                <ListItemText primary="Delivery Boys" />
              </ListItemButton>
            </ListItem>
          </>
        )}
      </List>
    </Drawer>
  );
}